import type { AxiosResponse } from "axios";
import { redirect } from "@tanstack/react-router";
import type { InferType } from "yup";
import * as yup from "yup";

import api from "../utils/AxiosInterceptor";
import userLocalStorage from "../utils/getUser";
import i18n from "../i18n";

export interface VerifyPasswordResponse {
  valid: boolean;
}

export async function verifyPassword(
  input: string,
): Promise<AxiosResponse<VerifyPasswordResponse>> {
  const userId = userLocalStorage()?.id;
  if (!userId) {
    throw redirect({ to: "/login" });
  }
  const response = await api.post("/api/v1/users/verify-password", {
    currentPassword: input,
    userId,
  });
  return response;
}

export const updatePasswordSchemaInput = yup.object({
  currentPassword: yup.string().required(() => i18n.t("validation.passwordRequiredMasc")),
  newPassword: yup.string().validatePassword(),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), undefined], () => i18n.t("validation.passwordsMustMatch"))
    .required(() => i18n.t("validation.passwordRequired")),
});

export type UpdatePasswordInput = InferType<typeof updatePasswordSchemaInput>;

export async function updateNewPassword(
  input: UpdatePasswordInput,
  userId: number,
): Promise<void> {
  await api.put(`/api/v1/users/${userId}/change-password`, input);
}
